import type React from 'react';
import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { PageLoading } from '@/app/components/page-loading.tsx';
import { useAuth } from '@/app/hooks/auth-provider';
import type { RepresentativeModel } from '../../types/representative.type.ts';
import type { StaffMemberModel } from '../../types/staff-member.type.ts';
import { UserTypeEnum } from '../../types/user-type.ts';

const LazyAccountUserProfile = lazy(() => import('./StaffMemberProfile.tsx'));
const LazyRepresentativeProfile = lazy(() => import('./RepresentativeProfile.tsx'));
const LazyAdminProfile = lazy(() => import('./AdminProfile.tsx'));

const MyProfile = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => {
  const { user } = useAuth();

  return (
    <Suspense fallback={<PageLoading />}>
      {user && user?.userType === UserTypeEnum.StaffMember && (
        <LazyAccountUserProfile user={user as StaffMemberModel} {...props} />
      )}
      {user && user?.userType === UserTypeEnum.DrugRep && (
        <LazyRepresentativeProfile user={user as RepresentativeModel} {...props} />
      )}
      {user && user?.userType === UserTypeEnum.Admin && <LazyAdminProfile user={user} {...props} />}
    </Suspense>
  );
};

export const myProfileRoute = {
  path: '/my-profile',
  element: <MyProfile />,
} as RouteObject;

export default MyProfile;
